import { render, staticRenderFns } from "./SocialSecurityContributions.vue?vue&type=template&id=1734b4d1&"
import script from "./SocialSecurityContributions.vue?vue&type=script&lang=js&"
export * from "./SocialSecurityContributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports